// Exported for apps/web/e2e/auth.setup.ts, which has to write this key
// directly (see there for why).
export const SESSION_TOKEN_STORAGE_KEY = 'floto.sessionToken';

/**
 * The session is carried as a bearer token instead of a cookie: Firebase
 * Hosting's rewrite to Cloud Run strips the Cookie request header, and
 * separately Chrome won't attach a cross-site cookie between the web.app and
 * run.app origins even when that header does survive. localStorage (not
 * sessionStorage) so a stored session survives closing the tab, matching the
 * 14-day lifetime the token itself carries.
 */
export function getSessionToken(): string | null {
  return localStorage.getItem(SESSION_TOKEN_STORAGE_KEY);
}

export function setSessionToken(token: string): void {
  localStorage.setItem(SESSION_TOKEN_STORAGE_KEY, token);
}

export function clearSessionToken(): void {
  localStorage.removeItem(SESSION_TOKEN_STORAGE_KEY);
}
